/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

import { ComponentClassNameFactory } from 'lib/contexts/ComponentClassNameFactory';
import getPropStylesFactory from 'lib/utils/getPropStylesFactory';
import getComponentStylesFactory from 'lib/utils/getComponentStylesFactory';
import getComponentThemeFactory from 'lib/utils/getComponentThemeFactory';
import make_styler from '../index';

export const styles = {
  "headline_colors_default": "text-black",
  "headline_size_default": "text-al-body-md",
  "headline_variant_default": "",
  "colors_default": "",
  "size_default": "w-full gap-3 mx-auto px-6 my-3 sm:my-4",
  "variant_default": "flex-nowrap flex-row flex items-center overflow-x-scroll overflow-y-visible scrollbar-none snap-x relative"
};

const c = make_styler(styles);

export const propClassName = getPropStylesFactory(c, styles, "TrendingMenu");

export const componentClassName = getComponentStylesFactory(propClassName);

export const componentTheme = getComponentThemeFactory(styles);

export const {
  ClassNameContext,
  ClassNameProvider,
  useClassName,
  useTheme,
} = ComponentClassNameFactory(componentClassName, styles);
  
export default c;